export default "__VITE_ASSET__ChSbp3____"